import Node from '../node.js';
import Spline from '../spline.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';

export default class NodeThickenCurve extends Node
{
	static THICKEN_CHOICES =
	[
		{key: 'middle', label: 'Middle'},
		{key: 'inside', label: 'Inside'},
		{key: 'outside', label: 'Outside'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'spline', null);

		this.addInput(PARAM_TYPE.FLOAT, 'thickness', 0.1, { minValue: 0.001, maxValue: 0.5, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.DROPDOWN, 'align', NodeThickenCurve.THICKEN_CHOICES[0].key, { dropdownOptions: NodeThickenCurve.THICKEN_CHOICES });

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{ 
		return 'thickenCurve';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(!inputValues['spline'])
			return null;

		let pSpline = new Spline(inputValues['spline'])

		let pointsInfo = pSpline.createThickPolyline(inputValues['thickness'], true, inputValues['align']);
		let pRes = new Spline(pointsInfo.points, true);
		return pRes.saveToObject();
	}
}